
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/duvidas-frequentes",
      function () {
        return require("private-next-pages/duvidas-frequentes.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/duvidas-frequentes"])
      });
    }
  